import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'saas_staff_library',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    bookList: function bookList() {
      var _this = this;
      var maxBook = {
        1: 5,
        2: 4,
        3: 3
      }[this.value.config.show_type];
      var result = Array.from({
        length: maxBook
      }, function (_, i) {
        var _this$value$config$bo;
        return (_this$value$config$bo = _this.value.config.books[i]) !== null && _this$value$config$bo !== void 0 ? _this$value$config$bo : {};
      });
      return result;
    }
  }
};